import "./cloud-transformation.css";
import { useNavigate } from "react-router-dom";
import useLocalizedPath from "../../../components/use-localized-path";
import { useTranslation } from "react-i18next";
import Timeline from "../../../components/timeline/timeline-comp";

export default function CloudTransformation() {
 const {t} = useTranslation();
  const navigate = useNavigate();
  const localize = useLocalizedPath();
  const goToContact = () => {
    navigate(localize("/contact-us"));
  };

  const goToAbout = () => {
    navigate(localize("/about-us"));
  };

  const timelineData = [
    {
      date: "01",
      title: "Scalable Cloud Infrastructure",
      content:
        "Infrastructure that dynamically adapts to your evolving business needs.",
    },
    {
      date: "02",
      title: "Cost Optimization",
      content:
        "Achieve cost-efficiency with pay-as-you-go models and reduced infrastructure expenses.",
    },
    {
      date: "03",
      title: "Seamless Collaboration",
      content:
        "Enable enhanced collaboration and remote work through cloud-based solutions.",
    },
    {
      date: "04",
      title: "Data Security and Recovery",
      content:
        "Strengthen disaster recovery, data protection, and backup reliability.",
    },
    {
      date: "05",
      title: "Agile Cloud Deployment",
      content:
        "Gain flexibility and speed in deploying new applications and scaling services.",
    },
  ];

  const challenges = [
    {
      number: "01",
      text: "Struggles with traditional on-premises infrastructure limiting scalability and increasing costs.",
    },
    {
      number: "02",
      text: "Hampers collaboration, misses opportunities, and reduces agility.",
    },
    {
      number: "03",
      text: "Complexity in managing IT environments without cloud technology adoption.",
    },
  ];

  const cards = [
    {
      icon: "fa-solid fa-cloud-arrow-up", // ✅ Free & visible
      title: "Guiding Cloud Transformation",
      text: "Guiding organizations through their cloud transformation journey.",
    },
    {
      icon: "fa-solid fa-server", // ✅ Represents infrastructure & migration analysis
      title: "Assessing Migration Needs",
      text: "Assessing existing infrastructure, identifying suitable workloads, and creating an effective migration strategy.",
    },
    {
      icon: "fa-solid fa-cloud", // ✅ General cloud symbol for tailored solutions
      title: "Tailoring Cloud Solutions",
      text: "Implementing tailored cloud solutions for data security, cost optimization, and maximizing performance.",
    },
  ];

  return (
    <div className="main-container">
      {/* main image section */}
      <section className="main-image-section cloud-transformation-section">
        <div className="main-image-dark-effect">
          <p className="sub-container-sub-heading">{t("Services")}</p>
          <h1 className="sub-container-heading">{t("Cloud Transformation")}</h1>
          <p className="sub-container-desc">
            {t("Scalable cloud solutions that modernize IT infrastructure, enhance flexibility, and reduce costs. Empower your business with secure, efficient, and future ready cloud adoption.")}
          </p>
          <div className="main-img-container-buttons">
            <button
              type="button"
              className="img-contact-btn common-btn-styles"
              onClick={goToContact}
            >
              {t("Contact Us")}
            </button>
            <button
              type="button"
              className="img-about-btn common-btn-styles"
              onClick={goToAbout}
            >
              {t("About Us")}
            </button>
          </div>
        </div>
      </section>

      {/* service overview section */}
      <section className="service-overview">
        <div className="service-overview-width sub-container">
          <div>
            <h2 className="sub-container-heading">{t("Service Overview")}</h2>
          </div>

          <div className="service-img-container">
            <div className="service-image">
              <img
                src="/assets/images/cloud-service-overview.webp"
                alt={t("Cloud Service Overview")}
              />
            </div>

            {/* Right Content */}
            <div className="service-content">
              <p>
                {t("Empowering businesses to modernize their infrastructure through secure, scalable, and cost-efficient cloud solutions. We ensure a seamless migration and optimization process that enhances agility, efficiency, and digital growth.")}
              </p>
              <ul>
                <li>
                  <i className="fa-solid fa-angles-right"></i>
                  {t("Specialized in cloud transformation services for organizations to harness its power.")}
                </li>
                <li>
                  <i className="fa-solid fa-angles-right"></i>
                  {t("Advantages of cloud technology: scalability, cost-efficiency, and cross-organizational collaboration.")}
                </li>
                <li>
                  <i className="fa-solid fa-angles-right"></i>
                  {t("Experts guiding through cloud migration, ensuring seamless transition and thriving in the digital era.")}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/*challenges secton*/}
      <section className="challenges-section sub-container">
        <h2 className="sub-container-heading">{t("Challenges")}</h2>
        <p className="sub-container-desc">
          {t("Common cloud challenges organizations face in today’s digital landscape.")}
        </p>

        <div className="challenges-container">
          {challenges.map((item, index) => (
            <div
              className="challenge-box"
              key={index}
              data-number={item.number}
            >
              <p className="challenge-text">{t(item.text)}</p>
            </div>
          ))}
        </div>
      </section>

      {/* how are we solving section */}
      <section className="solving-section">
        <div className="solving-section-container sub-container">
          <h2 className="sub-container-heading">{t("How Are We Solving")}</h2>
          <p className="sub-container-desc">
            {t("We combine strategic insight, cloud expertise, and collaboration to deliver cloud transformation services that help businesses modernize infrastructure, enhance scalability, and achieve greater efficiency through cloud-driven innovation.")}
          </p>

          <div className="solving-cards">
            {cards.map((card, index) => (
              <div className="solving-card" key={index}>
                <div className="icon-wrapper">
                  <i className={card.icon}></i>
                </div>
                <h3>{t(card.title)}</h3>
                <p>{t(card.text)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* benefits section */}
      <section className="benefits-section sub-container">
        <h2 className="sub-container-heading">{t("Benefits")}</h2>
        <p className="sub-container-desc">
          {t("With the quality and approach, we would be delivering the best of what you’d need in consulting, suggesting, providing right solutions thus yielding best benefits for your organizations productivity.")}
        </p>
        <div>
          <Timeline timelineData={timelineData} />
        </div>
      </section>
    </div>
  );
}
